import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, Navigate } from "react-router";

import { queryString } from "capitalrx-utilities";

import { ListLayout } from "@/basic/layouts";
import { MapBounds, PharmacyListContainer } from "@/basic/components";

export const PharmacyList = () => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const getCurrentQueryStrings = queryString.convertQueryStringToJson(location.search);

  const handleRedoSearch = (coordinates: MapBounds) => {
    const params = {
      lat: coordinates.center.latitude,
      lng: coordinates.center.longitude,
    };

    const newParams = queryString.convertJsonToQueryString({ ...getCurrentQueryStrings, ...params });

    navigate({
      pathname: "/pharmacy/list",
      search: newParams,
    });
  };

  const handleItemClick = (providerId: string) => {
    const params = {
      provider_id: providerId,
    };
    const newParams = queryString.convertJsonToQueryString({ ...getCurrentQueryStrings, ...params });

    navigate({
      pathname: "/pharmacy/details",
      search: newParams,
    });
  };

  const titleInfo = {
    clientName: getCurrentQueryStrings?.client?.toString()?.toUpperCase(),
    coverage:
      getCurrentQueryStrings?.coverage?.toString()?.charAt(0)?.toUpperCase() + getCurrentQueryStrings?.coverage?.toString()?.slice(1),
  };

  const isParamsSet
    = getCurrentQueryStrings.zip_code
    && getCurrentQueryStrings.client
    && getCurrentQueryStrings.lat
    && getCurrentQueryStrings.lng
    && getCurrentQueryStrings.coverage;

  if (!isParamsSet) {
    const client = getCurrentQueryStrings.client.toString();
    const notFoundParams = client ? queryString.convertJsonToQueryString({ client }) : undefined;

    return (
      <Navigate
        to={{
          pathname: "/404",
          search: notFoundParams,
        }}
      />
    );
  }

  return (
    <ListLayout
      pageTitle={`${translate("PHARMACY_LIST.localPharmacies")} ${titleInfo.clientName} ${titleInfo.coverage} ${translate("PHARMACY_LIST.network")}`}
      backButtonPath="/"
      backButtonParams={queryString.convertJsonToQueryString({ client: getCurrentQueryStrings.client.toString() })}
    >
      <PharmacyListContainer
        handleItemClick={handleItemClick}
        handleRedoSearch={handleRedoSearch}
        client={getCurrentQueryStrings.client.toString()}
        coverageType={getCurrentQueryStrings.coverage.toString()}
        zipCodeFormPushTo={`/pharmacy/list`}
      />
    </ListLayout>
  );
};
